<template>
  <div>
    <el-row>
      <el-col>
        <el-alert title="Dear merchant, this is simulate callback to your shop, please define 'returnUrl' to handle this on your site." type="warning" effect="dark" />
        <el-result
            v-if="respStatus === '1'"
            icon="success"
            title="Simulate callback to merchant"
            sub-title="Congratulations! Payment successful."
        >
        </el-result>
        <el-result
            v-if="respStatus !== '1'"
            icon="error"
            title="Simulate callback to merchant"
            sub-title="Your order payment failed. please check the description and try again."
        >
          <template #extra>
            <el-card style="max-width: 1000px">
              <template #header>
                <div class="card-header">
                  <span><p><b>Transaction ID:</b> {{ referenceNo }}</p></span>
                </div>
              </template>
              <el-descriptions title="Simulate order Info">
                <el-descriptions-item label="Transaction ID">{{ referenceNo }}</el-descriptions-item>
                <el-descriptions-item label="Order ID">{{ merOrderNo }}</el-descriptions-item>
                <el-descriptions-item label="WalletName">{{ walletName }}</el-descriptions-item>
                <el-descriptions-item label="Amount">
                  <el-tag size="small">{{ payAmount }} {{ payCurrency }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="Description">
                  {{ respDesc }}
                </el-descriptions-item>
              </el-descriptions>
            </el-card>
          </template>
        </el-result>
      </el-col>
    </el-row>
    <el-alert title="Dear merchant, this is simulate callback to your shop, please define 'returnUrl' to handle this on your site." type="error" />
    <el-row>
      <el-table :data="tableData" style="width: 100%; padding: 0 5% 0 5%">
        <el-table-column prop="key" label="Key" width="180" />
        <el-table-column prop="value" label="Value" />
      </el-table>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "SimulateCallback",
  data() {
    return {
      tableData : [],
      referenceNo: null,
      respStatus: null,
      payAmount: null,
      payCurrency: null,
      walletName: null,
      respDesc: null,
      merOrderNo: null,
    };
  },
  created() {
    const hash = window.location.hash;
    const queryParams = this.$route.query;
    if (hash.includes('simulate-callback')) {
      this.referenceNo = queryParams.referenceNo || 'N/A';
      this.respStatus = queryParams.respStatus || 'N/A';
      this.payAmount = queryParams.payAmount || 'N/A';
      this.payCurrency = queryParams.payCurrency || 'N/A';
      this.walletName = queryParams.walletName || 'N/A';
      this.respDesc = queryParams.respDesc || 'N/A';
      this.merOrderNo = queryParams.merOrderNo || 'N/A';
    }
    for (const key in queryParams) {
      if (Object.prototype.hasOwnProperty.call(queryParams, key)) {
        this.tableData.push({
          key: key,
          value: queryParams[key],
        });
      }
    }
  },
};
</script>

<style scoped>
p {
  margin: 10px 0;
}
</style>
